import type {LocaleCode} from '@helios/shared/locale/locales'

const ADVANCED_PLAN_COST_EURO = 69
const MAX_SPEND_EURO = 200_000
const ADVANCED_PLAN_COST_GBP = 69
const MAX_SPEND_GBP = 200_000
const ADVANCED_PLAN_COST_DKK = 620
const MAX_SPEND_DKK = 1_500_000
const ADVANCED_PLAN_COST_SEK = 830
const MAX_SPEND_SEK = 2_200_000

export const generateLocaleData = (code: LocaleCode) => {
    // only available in focus markets
    switch (code) {
        case 'es-es':
        case 'de-de':
        case 'fr-fr':
        case 'nl-nl':
            return {
                cost: ADVANCED_PLAN_COST_EURO,
                spend: MAX_SPEND_EURO,
            }
        case 'en-gb':
            return {
                cost: ADVANCED_PLAN_COST_GBP,
                spend: MAX_SPEND_GBP,
            }
        case 'da-dk':
            return {
                cost: ADVANCED_PLAN_COST_DKK,
                spend: MAX_SPEND_DKK,
            }
        case 'sv-se':
            return {
                cost: ADVANCED_PLAN_COST_SEK,
                spend: MAX_SPEND_SEK,
            }
        default:
            throw Error('Invalid locale code')
    }
}
